import { createRouter, createWebHistory } from 'vue-router'

import { app, pages } from '@/config'
import { useCommonStore } from '@/stores/common.js'
import { checkAffiliateMember, redirectWithAppsWebView } from '@/utils/member.js'
import { setLocalStorageData } from '@/utils/storage.js'

const WalletPage = () => import('@/pages/WalletPage.vue')
const SettingPage = () => import('@/pages/SettingPage.vue')
const ProfilePage = () => import('@/pages/ProfilePage.vue')
const SocialMediaPage = () => import('@/pages/SocialMediaPage.vue')
const TagLinkPage = () => import('@/pages/TagLinkPage.vue')
const TagLinkPerformancePage = () => import('@/pages/TagLinkPerformancePage.vue')
const SocialMediaLandingPage = () => import('@/pages/SocialMediaLandingPage.vue')
const PerformancePage = () => import('@/pages/PerformancePage.vue')
const TopProductPage = () => import('@/pages/TopProductPage.vue')
const TopSellingCategoryPage = () => import('@/pages/TopSellingCategoryPage.vue')
const TopSellingCategoryDetailPage = () => import('@/pages/TopSellingCategoryDetailPage.vue')
const HomePage = () => import('@/pages/HomePage.vue')
const RegistrationPage = () => import('@/pages/RegistrationPage.vue')
const OnboardingPage = () => import('@/pages/OnboardingPage.vue')
const MissionPage = () => import('@/pages/MissionPage.vue')
const MissionDetailPage = () => import('@/pages/MissionDetailPage.vue')
const BonusCommissionSellerPage = () => import('@/pages/BonusCommissionSellerPage.vue')
const InfoPage = () => import('@/pages/InfoPage.vue')
const NotFoundPage = () => import('@/pages/NotFoundPage.vue')

const TENANT_IDS = ['BLIBLI', 'TIKET']

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: pages.registration,
      name: app.routerName.registration,
      component: RegistrationPage
    },
    {
      path: pages.onboarding,
      name: app.routerName.onboarding,
      component: OnboardingPage
    },
    {
      path: pages.home,
      name: app.routerName.home,
      component: HomePage
    },
    {
      path: pages.wallet,
      name: app.routerName.wallet,
      component: WalletPage
    },
    {
      path: pages.setting,
      name: app.routerName.setting,
      component: SettingPage
    },
    {
      path: pages.profile,
      name: app.routerName.profile,
      component: ProfilePage
    },
    {
      path: pages.socialMedia,
      name: app.routerName.socialMedia,
      component: SocialMediaPage
    },
    {
      path: pages.tagLink,
      name: app.routerName.tagLink,
      component: TagLinkPage
    },
    {
      path: pages.tagLinkPerformance,
      name: app.routerName.tagLinkPerformance,
      component: TagLinkPerformancePage
    },
    {
      path: pages.socialMediaLanding,
      name: app.routerName.socialMediaLanding,
      component: SocialMediaLandingPage
    },
    {
      path: pages.socialMediaLandingApp,
      name: app.routerName.socialMediaLandingApp,
      component: SocialMediaLandingPage
    },
    {
      path: pages.performance,
      name: app.routerName.performance,
      component: PerformancePage
    },
    {
      path: pages.topProduct,
      name: app.routerName.topProduct,
      component: TopProductPage
    },
    {
      path: pages.topSellingCategory,
      name: app.routerName.topSellingCategory,
      component: TopSellingCategoryPage
    },
    {
      path: pages.topSellingCategoryDetail,
      name: app.routerName.topSellingCategoryDetail,
      component: TopSellingCategoryDetailPage
    },
    {
      path: pages.mission,
      name: app.routerName.mission,
      component: MissionPage
    },
    {
      path: pages.missionDetail,
      name: app.routerName.missionDetail,
      component: MissionDetailPage
    },
    {
      path: pages.bonusCommissionSeller,
      name: app.routerName.bonusCommissionSeller,
      component: BonusCommissionSellerPage
    },
    {
      path: pages.info,
      name: app.routerName.info,
      component: InfoPage
    },
    {
      path: pages.notFound,
      name: app.routerName.notFound,
      component: NotFoundPage
    }
  ]
})

router.afterEach((to, from) => {
  const isSamePage = to.path === from.path
  const isSameQuery = JSON.stringify(to.query) === JSON.stringify(from.query)
  const isAddAppsWebviewParam = !from.query.appsWebview && to.query.appsWebview
  const isRegistrationPage = to.path.startsWith(pages.registration)
  if (isSamePage && !isSameQuery && !isAddAppsWebviewParam || isRegistrationPage) {
    return
  }
  const commonStore = useCommonStore()
  commonStore.addPreviousRoute(from.path)
  // check if same page
  if (isSamePage) return
  // update meta and tracker
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = 'Blibli Tiket Affiliate'
  }
  // scroll to top on page visit
  window.scrollTo(0, 0)
})

router.beforeEach((to, from, next) => {
  const tenantId = to.query.tenantId

  if (TENANT_IDS.includes(tenantId)) {
    setLocalStorageData(app.localStorage.blibliTiketOriginSource, tenantId)
  }

  if (to.path.includes(app.publicPath)) {
    redirectWithAppsWebView(to, next)
  } else {
    checkAffiliateMember(to, next)
  }
})

export default router
